<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M4,2.4C4,.63,4.63,0,6.4,0H20l8,8.8V29.6c0,1.77-.63,2.4-2.4,2.4H6.4C4.63,32,4,31.37,4,29.6ZM19.2,7.2V1.6l7.2,8H21.6A2.12,2.12,0,0,1,19.2,7.2Z"
        style="fill-rule:evenodd" />
</svg>
